import { SectionContainer } from "@ext/catalog/actions/propsEditor/components/Sections/SectionContainer";
import { FeatureList } from "@ext/toggleFeatures/components/ToggleFeatures";

const ExperimentalSection = () => {
	return (
		<SectionContainer>
			<FeatureList />
		</SectionContainer>
	);
};

export default ExperimentalSection;
